import styles from "../../styles/empty.module.scss";

export const Empty = ({ children }) => {
  return <div className={styles.emptyContainer}>{children}</div>;
};
